import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Recaptcha 3
import { RecaptchaV3Module } from 'ng-recaptcha';

// Kendo UI stuff
import { IntlModule } from '@progress/kendo-angular-intl';
import '@progress/kendo-angular-intl/locales/ro/all';

import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { UploadsModule } from '@progress/kendo-angular-upload';

// kendo services
import { TranslateFilterPipe } from './pipes/translate-filter.pipe';

import { PopoverModule, TooltipsModule } from '@progress/kendo-angular-tooltip';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CfDocumentSecuredSessionComponent } from './components/cf-document-secured-session/cf-document-secured-session.component';
import { AttachmentFilesTabComponent } from './components/cf-document/attachment-files-tab/attachment-files-tab.component';
import { CfDocumentComponent } from './components/cf-document/cf-document.component';
import { DocumentFilesTabComponent } from './components/cf-document/document-files-tab/document-files-tab.component';
import { DocumentInfoSectionComponent } from './components/cf-document/document-info-section/document-info-section.component';
import { EventsTabComponent } from './components/cf-document/events-tab/events-tab.component';
import { CfSignatureQrComponent } from './components/cf-signature-qr/cf-signature-qr.component';
import { SignOnGlassComponent } from './components/cf-signature/sign-on-glass/sign-on-glass.component';
import { SignWithPinCodeComponent } from './components/cf-signature/sign-with-pin-code/sign-with-pin-code.component';
import { SignaturesComponent } from './components/cf-signature/signatures/signatures.component';
import { CompanyTasksComponent } from './components/company-tasks/company-tasks.component';
import { RegisterEventComponent } from './components/company-tasks/create-task/register-event.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SsoComponent } from './components/sso/sso.component';
import { ThanksForSigningComponent } from './components/thanks-for-signing/thanks-for-signing.component';
import { CoreModule } from './core.module';
import { CopyClipboardDirective } from './directives/copy-clipboard.directive';

@NgModule({
    declarations: [
        // pipes
        TranslateFilterPipe,

        // components
        AppComponent,
        HeaderComponent,
        HomeComponent,
        CfDocumentComponent,
        DocumentFilesTabComponent,
        AttachmentFilesTabComponent,
        EventsTabComponent,
        SignaturesComponent,
        SignWithPinCodeComponent,
        SignOnGlassComponent,
        LoginComponent,
        CompanyTasksComponent,
        RegisterEventComponent,
        SsoComponent,
        NotFoundComponent,
        ThanksForSigningComponent,
        CfSignatureQrComponent,
        DocumentInfoSectionComponent,
        CfDocumentSecuredSessionComponent,
        CopyClipboardDirective
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        RecaptchaV3Module,
        CoreModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient]
            }
        }),

        // kendo
        ButtonsModule,
        NavigationModule,
        IconsModule,
        DropDownsModule,
        LayoutModule,
        LabelModule,
        InputsModule,
        NotificationModule,
        IntlModule,
        GridModule,
        IndicatorsModule,
        DialogsModule,
        UploadsModule,
        TooltipsModule,
        PopoverModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {}

// required for AOT compilation
export function httpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}
